// extracted by mini-css-extract-plugin
module.exports = {"button":"button-button__tF-Eo","button_disabled":"button-button_disabled__3QwMo","button_white":"button-button_white__c6Q4y","button_red":"button-button_red__1Au_U"};